import CreateProjectContainer from "../../Componant/Project/CreateProject";

const CreateProject = () => {
  return (
    <div className="page-body">
      <CreateProjectContainer />
    </div>
  );
};

export default CreateProject;
